<template>
  <div class="h-full">
    <slider
      animation="fade"
      :indicators="false"
      :interval="this.duration"
      :speed="500"
      height="100vh"
    >
      <template v-for="(item, i) in this.news">
        <slider-item
          :key="i"
          :style="i"
        >
          <div class="md:flex p-4">
            <!-- <div v-if="item.img" class="md:flex-shrink-0">
              <img v-if="item.img.src" class="rounded-lg md:w-56" :src="item.img.src" :alt="item.img.alt">
            </div> -->
            <div class="mt-4 md:mt-0 md:ml-6">
              <div class="uppercase tracking-wide text-sm text-indigo-600 font-bold" v-html="item.title"></div>
              <a v-if="item.leading" href="#" class="block mt-1 text-lg leading-tight font-semibold text-gray-900 hover:underline" v-html="item.leading"></a>
              <p class="mt-2 text-gray-600" v-html="item.body"></p>
            </div>
          </div>

        </slider-item>
    </template>
    </slider>
  </div>
</template>

<script>
export default {
  name: 'NewsWidget',
  props: ['news', 'duration'],
  data() {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
